<script>
  import { createEventDispatcher } from "svelte";
  import { DataTable} from "carbon-components-svelte";
  import { Pagination, TextInput, Button } from "paxray-components-svelte";
  import { EDIT_ICON } from "@utils/icons.js";

  export let uilistfilter;
  export let isCompleted = true;
  export let fulluilist;
  export let name = null;
  export let headers;
  export let uilistfilterelements = [];
  export let functionButton = false;

  let uipage = 1;
  let uipageSize;
  let uilist = fulluilist;

  let dispatch = createEventDispatcher();

  function edit(row) {
    dispatch("editApp", { row });
  }

  function functionButtonPressed() {
    dispatch("functionButtonPressed", { uilistfilter });
  }

  function filterUIList() {
    uilist = fulluilist.filter((item) => {
      let matches = true;
      headers.forEach((e) => {
        if (e.filterable !== false && uilistfilter[e.key] != "") {
          if (uilistfilter[e.key] === " ") {
            matches = matches && (item[e.key] === null || item[e.key] === "");
          } else if (e.regex !== true) {
            let char = "" + item[e.key];
            matches =
              matches &&
              char.toLowerCase().includes(uilistfilter[e.key].toLowerCase());
          } else {
            try {
              const dataRegexp = new RegExp(uilistfilter[e.key], "i");
              matches = matches && dataRegexp.test(item[e.key]);
            } catch (e) {
              matches = false;
            }
          }
        }
      });
      return matches;
    });
  }

  function orderElements(list) {
    if (!list) return [];
    return list.sort((a, b) => {
      const aValue = a === null ? "" : a;
      const bValue = b === null ? "" : b;
      return aValue.toLowerCase().localeCompare(bValue.toLowerCase());
    });
  }

  function displayElement(element) {
    return element === null || element === "" ? " " : element;
  }

  $: {
    if (uilistfilter) filterUIList();
  }
</script>

{#if name}
  <div class="table_heading bold">{name}</div>
{/if}
<table>
  <tr>
    {#each headers as element}
      {#if element.filterable != false}
        <td>
          <TextInput
            labelText={element.value}
            size="sm"
            bind:value={uilistfilter[element.key]}
            placeholder={uilistfilterelements.hasOwnProperty(element.key)
              ? `All ${element.value}s`
              : element.value}
            list={element.key}
          />
        </td>
        {#if uilistfilterelements.hasOwnProperty(element.key)}
          <datalist id={element.key}>
            {#each orderElements(uilistfilterelements[element.key]) as application}
              <option value={displayElement(application)} />
            {/each}
          </datalist>
        {/if}
      {/if}
    {/each}
    {#if functionButton}
      {#if functionButton === true}
        <td style="text-align: center;">
          <Button
            size="small"
            kind="secondary"
            icon={EDIT_ICON}
            on:click={() => {
              functionButtonPressed();
            }}
            iconDescription="Create Rule From Entry"
          />
        </td>
      {:else}
        <td style=" width: 1%; white-space: nowrap; vertical-align: bottom;">
          <Button
            text={functionButton}
            kind="secondary"
            loading={isCompleted}
            on:click={() => {
              functionButtonPressed();
            }}
          />
        </td>
      {/if}
    {/if}
  </tr>
</table>

<DataTable
  size="short"
  {headers}
  rows={uilist}
  sortable
  page={uipage}
  pageSize={uipageSize}
  sortDirection="desc"
  sortKey="count"
>
  <svelte:fragment slot="cell" let:cell let:row>
    {#if cell.key === "menu" && !isCompleted}
      <Button
        size="small"
        kind="secondary"
        icon={EDIT_ICON}
        on:click={() => {
          edit(row);
        }}
        iconDescription="Create Rule From Entry"
      />
    {:else if cell.key !== "menu"}
      <div class="button_wrapper" title={cell.value}>
        {cell.value}
      </div>
    {/if}
  </svelte:fragment>
</DataTable>
<Pagination
  dark
  totalItems={uilist.length}
  pageSizes={[10, 25, 50]}
  bind:page={uipage}
  bind:pageSize={uipageSize}
/>

<style>
  .button_wrapper {
    overflow-x: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
</style>
